import React, { FC } from 'react';

import { Box, Space } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { Form } from 'components/forms/Form';
import { FormSubmit } from 'components/forms/FormSubmit';
import { TextField } from 'components/forms/fields/TextField';
import { ModalDescription } from 'components/modals/ModalDescription';
import { ModalTitle } from 'components/modals/ModalTitle';
import { useCurrentTeam } from 'hooks/use-current-team';
import { InternalTrackingService } from 'services/InternalTrackingService';
import { TeamService } from 'services/TeamService';

type Values = {
    name: string;
};

const TeamNameRequiredModal: FC<ContextModalProps> = ({ context, id }) => {
    const team = useCurrentTeam();

    const submit = async (values: Values) => {
        await InternalTrackingService.skip(async () => {
            await TeamService.update(team!.id, {
                name: values.name,
            });
        });

        context.closeModal(id);
    };

    return (
        <Box>
            <Space h="xs" />
            <ModalTitle maw="80%" textWrap="balance" mx="auto">
                A team name is required
            </ModalTitle>
            <Space h="xs" />
            <ModalDescription ta="center">
                It looks like your team does not have a name.
                <br />
                Please set a team name to continue.
            </ModalDescription>
            <Space h="lg" />
            <Form<Values>
                defaultValues={{
                    name: '',
                }}
                onSubmit={submit}
            >
                <TextField name="name" label="Team Name" placeholder="Enter a team name" required />
                <Space h="xs" />
                <FormSubmit>Set name</FormSubmit>
            </Form>
            <Space h="xs" />
        </Box>
    );
};

export { TeamNameRequiredModal };
